import { type Action, Actions, type State } from './types';

const initVals: State = {
  errors: [],
  isResetEnabled: false,
  isValidating: false,
  validItems: [],
  value: '',
};

export const reducer = (state: State = initVals, action: Action): State => {
  switch (action.type) {
    case Actions.Change_Handler: {
      return {
        ...state,
        value: action.payload.text,
        isResetEnabled: true,
      };
    }
    case Actions.Reset: {
      return {
        value: action.payload.formattedText,
        isResetEnabled: false,
        errors: [],
        validItems: [],
        isValidating: false,
      };
    }
    case Actions.Validate: {
      return {
        errors: action.payload.errors,
        validItems: action.payload.validItems,
        value: action.payload.text,
        isResetEnabled: true,
        isValidating: false,
      };
    }
    case Actions.SetResetEnabled: {
      return {
        ...state,
        isResetEnabled: true,
      };
    }
    case Actions.SetValidating: {
      return {
        ...state,
        isValidating: action.payload,
      };
    }

    default:
      return state;
  }
};
